/**
 * Klantteksten rond vectorbestanden (EPS, AI, PS, SVG), in de vier talen die
 * eerst moeten kloppen. Eén plek, zodat offertepagina, uploader en
 * ontwerpmodule hetzelfde zeggen.
 */

export type ArtworkCopyLocale = 'nl' | 'en' | 'de' | 'fr';

export const ARTWORK_COPY = {
  nl: {
    needsConversion: 'We zetten dit bestand voor je om en controleren het voor het drukken. Je kunt gewoon verder met bestellen.',
    editorPreview: 'Dit is een voorbeeld om je logo te plaatsen. We zetten het originele bestand voor je om en controleren het voor het drukken.',
    editorConverted: 'Je vectorbestand is omgezet en geplaatst.',
    converting: 'Bestand wordt omgezet...',
    invalid: 'Dit bestand is beschadigd of past niet bij de extensie. Kies een ander bestand of een PDF.',
    failed: 'Het bestand kon niet worden verwerkt. Probeer het opnieuw.',
    formats: 'PDF, AI, EPS, PS, SVG, PNG, JPG of WEBP',
  },
  en: {
    needsConversion: 'We will convert this file for you and check it before printing. You can simply continue with your order.',
    editorPreview: 'This is a preview so you can position your logo. We will convert the original file for you and check it before printing.',
    editorConverted: 'Your vector file has been converted and placed.',
    converting: 'Converting file...',
    invalid: 'This file is damaged or does not match its extension. Choose another file or a PDF.',
    failed: 'The file could not be processed. Please try again.',
    formats: 'PDF, AI, EPS, PS, SVG, PNG, JPG or WEBP',
  },
  de: {
    needsConversion: 'Wir wandeln diese Datei für Sie um und prüfen sie vor dem Druck. Sie können ganz normal weiter bestellen.',
    editorPreview: 'Dies ist eine Vorschau zum Platzieren Ihres Logos. Wir wandeln die Originaldatei für Sie um und prüfen sie vor dem Druck.',
    editorConverted: 'Ihre Vektordatei wurde umgewandelt und platziert.',
    converting: 'Datei wird umgewandelt...',
    invalid: 'Diese Datei ist beschädigt oder passt nicht zur Dateiendung. Wählen Sie eine andere Datei oder ein PDF.',
    failed: 'Die Datei konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.',
    formats: 'PDF, AI, EPS, PS, SVG, PNG, JPG oder WEBP',
  },
  fr: {
    needsConversion: 'Nous convertissons ce fichier pour vous et le vérifions avant l’impression. Vous pouvez poursuivre votre commande.',
    editorPreview: 'Ceci est un aperçu pour placer votre logo. Nous convertissons le fichier original pour vous et le vérifions avant l’impression.',
    editorConverted: 'Votre fichier vectoriel a été converti et placé.',
    converting: 'Conversion du fichier...',
    invalid: 'Ce fichier est endommagé ou ne correspond pas à son extension. Choisissez un autre fichier ou un PDF.',
    failed: 'Le fichier n’a pas pu être traité. Veuillez réessayer.',
    formats: 'PDF, AI, EPS, PS, SVG, PNG, JPG ou WEBP',
  },
} as const;

export function artworkCopy(locale: string | null | undefined) {
  const key = String(locale || 'nl').toLowerCase().split('-')[0] as ArtworkCopyLocale;
  return ARTWORK_COPY[key] || ARTWORK_COPY.en;
}
